{
  "kind": {
    "warmup": "Warm up",
    "cooldown": "Cool down",
    "recovery": "Recovery",
    "rest": "Rest",
    "interval": "Interval",
    "active": "Active",
    "other": "Work"
  },
  "target": {
    "percentMax": "@ {{value}}% max",
    "stroke": "Stroke",
    "easy": "Easy"
  },
  "load": {
    "recovery": "Recovery",
    "moderate": "Moderate",
    "hard": "Hard",
    "veryHard": "Very Hard"
  }
}
